import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setUserNew } from "./userNewSlice";
import { baseUrl } from "../../../services/baseUrl";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    // baseUrl: "https://storextest.payx.am/api/User",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token"); 
      if (token) {
        headers.set("Authorization", `Bearer ${token}`); 
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    userNew: builder.query({
      query:(credentials) => ({
        url:`/GetUser`,
        method: "GET",
        body: credentials 
      }),
      onQueryStarted: async (credentials, { dispatch, queryFulfilled }) => {
        try {

          const { data, meta } = await queryFulfilled;
          console.log("data", data)
          dispatch(setUserNew(data?.data))
        } catch(error) {
          console.error("Error fetching user data:", error);
        }
      },
    }),

    
  })
});

export const {
  useLazyUserNewQuery,
  useUserNewQuery
} = userApi;
